// Thin lucide-react wrapper: kebab icon names, default size 16, stroke-width 1.75.
// Falls back to a box glyph for unknown names. Ported from botriq-admin-fe.
import * as Lucide from "lucide-react";
import PropTypes from "prop-types";

// "package-check" -> "PackageCheck"
const toPascal = (name) =>
  name
    .split("-")
    .map((s) => s.charAt(0).toUpperCase() + s.slice(1))
    .join("");

export const Icon = ({ name, size = 16, strokeWidth = 1.75, color, style, ...rest }) => {
  const Cmp = Lucide[toPascal(name)] || Lucide.Square;
  return (
    <Cmp
      size={size}
      strokeWidth={strokeWidth}
      style={{ flex: "none", ...(color ? { color } : {}), ...style }}
      {...rest}
    />
  );
};

Icon.propTypes = {
  name: PropTypes.string.isRequired,
  size: PropTypes.number,
  strokeWidth: PropTypes.number,
  color: PropTypes.string,
  style: PropTypes.object,
};

export default Icon;
